/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ShadowMCPAccessSummary,
  ShadowMCPAccessSummary$inboundSchema,
} from "./shadowmcpaccesssummary.js";
import {
  ShadowMCPInventoryApprovalRequest,
  ShadowMCPInventoryApprovalRequest$inboundSchema,
} from "./shadowmcpinventoryapprovalrequest.js";
import {
  ShadowMCPInventoryRequestSummary,
  ShadowMCPInventoryRequestSummary$inboundSchema,
} from "./shadowmcpinventoryrequestsummary.js";

/**
 * Deprecated: read access_summary.state. Kept one release so older clients keep rendering, then removed together with making access_summary required. Note the values themselves are corrected in this release: URLs whose bypass grants cover only part of a policy's audience now read restricted where they previously read allowed.
 */
export const ShadowMCPInventoryURLStateAccess = {
  None: "none",
  Allowed: "allowed",
  Blocked: "blocked",
  Restricted: "restricted",
} as const;
/**
 * Deprecated: read access_summary.state. Kept one release so older clients keep rendering, then removed together with making access_summary required. Note the values themselves are corrected in this release: URLs whose bypass grants cover only part of a policy's audience now read restricted where they previously read allowed.
 */
export type ShadowMCPInventoryURLStateAccess = ClosedEnum<
  typeof ShadowMCPInventoryURLStateAccess
>;

export type ShadowMCPInventoryURLState = {
  /**
   * Deprecated: read access_summary.state. Kept one release so older clients keep rendering, then removed together with making access_summary required. Note the values themselves are corrected in this release: URLs whose bypass grants cover only part of a policy's audience now read restricted where they previously read allowed.
   */
  access: ShadowMCPInventoryURLStateAccess;
  /**
   * The enforcement verdict for a shadow MCP server, computed server-side from policies, grants, and the recorded decision. state is the canonical compression of who may call the server; the remaining fields name the mechanisms so a client renders wording without re-deriving enforcement.
   */
  accessSummary?: ShadowMCPAccessSummary | undefined;
  allowedPolicyIds: Array<string>;
  /**
   * The MCP approval request tracking review status for a server. Status records the review outcome, which may cover only selected principals; the server's access field reports enforcement state.
   */
  approvalRequest?: ShadowMCPInventoryApprovalRequest | undefined;
  /**
   * Enabled blocking policies that block this server via a risk_policy:block grant (allow_all policies only).
   */
  blockedPolicyIds: Array<string>;
  latestRequest?: ShadowMCPInventoryRequestSummary | undefined;
  requestCount: number;
};

/** @internal */
export const ShadowMCPInventoryURLStateAccess$inboundSchema: z.ZodMiniEnum<
  typeof ShadowMCPInventoryURLStateAccess
> = z.enum(ShadowMCPInventoryURLStateAccess);

/** @internal */
export const ShadowMCPInventoryURLState$inboundSchema: z.ZodMiniType<
  ShadowMCPInventoryURLState,
  unknown
> = z.pipe(
  z.object({
    access: ShadowMCPInventoryURLStateAccess$inboundSchema,
    access_summary: z.optional(ShadowMCPAccessSummary$inboundSchema),
    allowed_policy_ids: z.array(z.string()),
    approval_request: z.optional(
      ShadowMCPInventoryApprovalRequest$inboundSchema,
    ),
    blocked_policy_ids: z.array(z.string()),
    latest_request: z.optional(ShadowMCPInventoryRequestSummary$inboundSchema),
    request_count: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "access_summary": "accessSummary",
      "allowed_policy_ids": "allowedPolicyIds",
      "approval_request": "approvalRequest",
      "blocked_policy_ids": "blockedPolicyIds",
      "latest_request": "latestRequest",
      "request_count": "requestCount",
    });
  }),
);

export function shadowMCPInventoryURLStateFromJSON(
  jsonString: string,
): SafeParseResult<ShadowMCPInventoryURLState, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ShadowMCPInventoryURLState$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ShadowMCPInventoryURLState' from JSON`,
  );
}
